// instant-page.js v5.2.0 — hover pe page prefetch karo taaki click instant lage
// Source: https://instant.page (MIT License)
// Self-hosted to avoid external CDN dependency

let mouseoverTimer
let lastTouchTimestamp
const prefetched = new Set()
const prefetchElement = document.createElement('link')
const isSupported = prefetchElement.relList && prefetchElement.relList.supports && prefetchElement.relList.supports('prefetch') && window.IntersectionObserver && 'isIntersecting' in IntersectionObserverEntry.prototype

// Shopify-specific: in-cart / checkout / account pages skip karo
const SKIP_PATTERNS = ['/cart', '/checkout', '/account', '/password', 'cdn.shopify', '#', 'mailto:', 'tel:']

function isSkipped(url) {
  if (!url) return true
  for (const p of SKIP_PATTERNS) {
    if (url.includes(p)) return true
  }
  // Same domain only
  try {
    const u = new URL(url, location.href)
    if (u.host !== location.host) return true
  } catch {
    return true
  }
  return false
}

function prefetch(url) {
  if (prefetched.has(url) || isSkipped(url)) return
  prefetched.add(url)
  const link = document.createElement('link')
  link.rel = 'prefetch'
  link.href = url
  link.as = 'document'
  document.head.appendChild(link)
}

function getLinkFromTarget(target) {
  return target instanceof HTMLAnchorElement ? target : target.closest('a[href]')
}

if (isSupported) {
  document.addEventListener('touchstart', (e) => {
    lastTouchTimestamp = performance.now()
    const link = getLinkFromTarget(e.target)
    if (link) prefetch(link.href)
  }, { capture: true, passive: true })

  document.addEventListener('mouseover', (e) => {
    if (performance.now() - lastTouchTimestamp < 1100) return
    const link = getLinkFromTarget(e.target)
    if (!link) return
    mouseoverTimer = setTimeout(() => prefetch(link.href), 65)
  })

  document.addEventListener('mouseout', (e) => {
    if (getLinkFromTarget(e.target)) clearTimeout(mouseoverTimer)
  })
}
